<template>
  <div>
  <app-masthead :header="header"/>
  <v-container grid-list-xl >
     <v-layout wrap row class="mb-5">
      <v-flex xs12>
        <h2 style="font-size: 36px; font-weight: bold; line-height: 1.2;" class="mb-2">Wir sehen jeden einzelnen Menschen als Schöpfer!</h2>
        <p>Egal ob im klassischen Arbeitskontext, im Hobby-Bereich oder in der Familie. Wir schaffen Möglichkeitsräume, um diese in uns allen wohnende schöpferische Kraft fördern und entfalten zu können und somit ein Teil dazu beizutragen die Kultur der Potenzialentfaltung in unserer Gesellschaft zu verankern.</p>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-flex xs12 sm10 style="text-align: center; background: rgb(36,196,161); background: linear-gradient(118deg, rgba(36,196,161,1) 0%, rgba(95,209,184,1) 100%); border-radius: 8px;">
        <h3 style="color: white;">Übungen zur Achtsamkeit</h3>
        <p style="color: white;">Melde dich an und erhalte jede Woche eine neue Übung per E-Mail.</p>
        <v-btn outline color="white" href="http://eepurl.com/dhiZT9" target="_blank">zur Anmeldung</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12 style="text-align: center;" class="py-10">
      <h4>Instagram</h4>
      <vue-instagram token="7181829859.1677ed0.1145d06cef9e4d989eabdb4dd8dcf232" :count="2" mediaType="image" class="layout row wrap justify-center">
        <template slot="feeds" slot-scope="props">
          <v-flex xs6 sm4>
            <a target="_blank" :href="props.feed.link">
              <img style="width: 100%;" :src=" props.feed.images.standard_resolution.url " alt="">
            </a>
          </v-flex>
        </template>
        <template slot="error" slot-scope="props">
          <div class="fancy-alert"> {{ props.error.error_message }} </div>
        </template>
      </vue-instagram>
    </v-flex>
    </v-layout>

    <app-cta-newsletter/>
  </v-container>
  </div>
</template>

<script>
import VueInstagram from 'vue-instagram'

export default {
  data () {
    return {
      dialog: false,
      header: {
        src: require('@/assets/ip-header-start.svg'),
        title: 'Gemeinsam. Potenziale. Entdecken.',
        description: 'Eine Idee ist am schönsten, wenn sie am Ende auch verwirklicht wird.'
      },
      tiles: [
        { img: 'keep.png', title: 'Keep' },
        { img: 'inbox.png', title: 'Inbox' },
        { img: 'hangouts.png', title: 'Hangouts' },
        { img: 'messenger.png', title: 'Messenger' },
        { img: 'google.png', title: 'Google+' }
      ]
    }
  },
  components: {
    VueInstagram
  }
}
</script>

<style lang="scss">
  .v-bottom-sheet.v-dialog {
    background-color: white;
  }
  .py-10 {
    padding-top: 100px !important;
    padding-bottom: 100px !important;
  }
  .disabled {
    pointer-events:none; 
    opacity:0.3;
  }
  .ip-btn {
    border-radius: 3px;
    text-align: center;
    border: 1px solid black;
    padding: 15px 0px;

    &:hover {
      background-color: #eee;
    }
  }
  .home-start .v-card {
    &:hover {
      background-color: var(--v-warning-base) !important;
      h3, p {
        color: white;
      }
    }
  }
</style>
